import SbEditable from "storyblok-react";
import config from "config/config";
import type { StoryblokComponent } from "storyblok-js-client";
import WhyChooseAirHelp from "../components/WhyChooseAirHelp";
import type { DynamicComponentProps } from "./DynamicComponent.d";

import {
  Button,
  Cards,
  CheckList,
  Content,
  Image,
  InfoBox,
  Subscribe,
  Table,
  CTA,
  ImageCTA,
  SideBarHeading,
  LinkBox,
  ErrorComponent,
  Column,
  Heading,
  Row,
  Link,
  LegalContent,
  BlogLegacyContent,
  Trustpilot,
  TrustpilotReviewCard,
  Anchor,
  Logo,
  Flags,
  HeroForm,
  TrustpilotSlider,
  Accordion,
  HelpQuestion,
  Spacer,
  Schema,
  ComparisonCards,
  PieChart,
  Icon,
  TextSwitcher,
  AhPlusPricingPlans,
  CompensationFeeCards,
  FeeModelCards,
  BarcodeScannerButton,
  AboveTheFoldCTASection,
  TrustpilotExtended,
  AboveTheFoldAutocompleteSection,
  TestimonialsSection,
  PressCoverageItem,
  ContentWithImageSection,
  ListCard,
  HeroImageSection,
  PartnerCards,
  PartnersHero,
  OurFeesCompensationTable,
  TrustpilotTestimonial,
  AboutUsTrustpilotSection,
  OurTeamSection,
  Collapsible,
} from "../adapters/index";

const developmentEnvironment = config.buildEnv === "development";

// resolve Storyblok components to Next.js components
const Components = {
  sideBarHeading: SideBarHeading,
  heading: Heading,
  content: Content,
  ctaSection: CTA,
  ctaImageSection: ImageCTA,
  legalContent: LegalContent,
  blogLegacyContent: BlogLegacyContent,
  image: Image,
  row: Row,
  column: Column,
  link: Link,
  linkBox: LinkBox,
  infoBox: InfoBox,
  checkList: CheckList,
  table: Table,
  subscribe: Subscribe,
  cards: Cards,
  button: Button,
  trustpilotReview: TrustpilotReviewCard,
  trustpilot: Trustpilot,
  anchor: Anchor,
  logo: Logo,
  flags: Flags,
  heroForm: HeroForm,
  trustpilotSlider: TrustpilotSlider,
  accordion: Accordion,
  helpQuestion: HelpQuestion,
  whyChooseAirHelp: WhyChooseAirHelp,
  spacer: Spacer,
  schema: Schema,
  comparisonCards: ComparisonCards,
  pieChart: PieChart,
  icon: Icon,
  textSwitcher: TextSwitcher,
  ahPlusPricingPlans: AhPlusPricingPlans,
  compensationFeeCards: CompensationFeeCards,
  feeModelCards: FeeModelCards,
  barcodeScannerButton: BarcodeScannerButton,
  aboveTheFoldCTASection: AboveTheFoldCTASection,
  trustpilotExtended: TrustpilotExtended,
  aboveTheFoldAutocompleteSection: AboveTheFoldAutocompleteSection,
  testimonialsSection: TestimonialsSection,
  pressCoverageItem: PressCoverageItem,
  contentWithImageSection: ContentWithImageSection,
  listCard: ListCard,
  heroImageSection: HeroImageSection,
  partnerCards: PartnerCards,
  partnersHero: PartnersHero,
  ourFeesCompensationTable: OurFeesCompensationTable,
  trustpilotTestimonial: TrustpilotTestimonial,
  ourTeamSection: OurTeamSection,
  aboutUsTrustpilotSection: AboutUsTrustpilotSection,
  collapsible: Collapsible,
};

const DynamicComponent = ({ blok }: DynamicComponentProps) => {
  const Component = Components[blok.component] || (developmentEnvironment && ErrorComponent);
  if (!Component) return null;

  return (
    // @ts-ignore
    <SbEditable content={blok}>
      <Component blok={blok} />
    </SbEditable>
  );
};

export const renderDynamicComponent = (body: StoryblokComponent<string>[]) =>
  body ? body.map((blok) => <DynamicComponent blok={blok} key={blok._uid} />) : null;

export default DynamicComponent;
